import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var emptyClassName = '';
var IconClassNameContext = /*#__PURE__*/createContext(emptyClassName);
var Provider = IconClassNameContext.Provider,
    IconClassNameConsumer = IconClassNameContext.Consumer;

var IconClassNameProvider = function IconClassNameProvider(_ref) {
  var children = _ref.children,
      className = _ref.value;
  return /*#__PURE__*/React.createElement(IconClassNameConsumer, null, function (outerClassName) {
    return /*#__PURE__*/React.createElement(Provider, {
      value: classNames(className, outerClassName)
    }, children);
  });
};

process.env.NODE_ENV !== "production" ? IconClassNameProvider.propTypes = {
  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * The CSS class name of `Icon`.
   */
  value: PropTypes.string
} : void 0;
export default IconClassNameContext;
export { IconClassNameConsumer, IconClassNameProvider };